import { Active } from '@dnd-kit/core';
import { getDndActiveItemData } from '../../../DndEntity/utils';
import { IEventEntitySelection } from './types';

// helper function that checks whether there is an error for the events input
// currently there are 2 errors to check
// 1. If the user is dragging an event that is already in the input over the input
// 2. If the user is dragging differeing event types into the builder (eg. Virtual event into basic events array)
export const checkEventTypeError = ({
  typename,
  keyOrId,
  events,
}: {
  typename: 'BasicEventValue' | 'VirtualEvent';
  keyOrId: string;
  events: IEventEntitySelection[];
}) => {
  const foundEvent = events.find(
    (event) =>
      event.__typename === typename &&
      (event.__typename === 'VirtualEvent'
        ? event.id === keyOrId
        : event.value.key === keyOrId),
  );

  if (foundEvent) {
    return true;
  }

  return events.some((event) => event.__typename !== typename);
};

export const getBuilderEventsInputCustomMessage = ({
  activeItem,
  events,
}: {
  activeItem: Active | null;
  events: IEventEntitySelection[];
}) => {
  const data = getDndActiveItemData(activeItem);

  if (!data) {
    return;
  }

  const eventTypes: { [key: string]: string } = {
    TagLeafBasicEvent: 'BasicEventValue',
    TagLeafVirtualEvent: 'VirtualEvent',
  };

  const eventType = eventTypes[data.__typename];
  if (!eventType) {
    return;
  }

  const foundEvent = events.find(
    (event) =>
      event.__typename === eventType &&
      (event.__typename === 'BasicEventValue'
        ? event.value.key === data.key
        : event.__typename === 'VirtualEvent'
          ? event.id === data.id
          : null),
  );

  if (foundEvent) {
    return 'Event already exists';
  }

  if (
    eventType === 'VirtualEvent' &&
    events.some((event) => event.__typename === 'VirtualEvent')
  ) {
    return 'Only 1 virtual event can be added';
  }

  const otherEventType =
    data.__typename === 'TagLeafBasicEvent'
      ? 'VirtualEvent'
      : 'BasicEventValue';
  if (events.some((event) => event.__typename === otherEventType)) {
    return `Cannot add ${
      data.__typename === 'TagLeafBasicEvent' ? 'Basic' : 'Virtual'
    } Event`;
  }

  return '+ Add Event';
};
